import { Board, ProductionStatus } from "../../reducers/uploadedBoard";
import { OptionContainer, OptionLine, OptionTitle } from "./SelectOptionStyles";
import { dateStringToHumanReadableDate } from "../../utils/valueFormatting";
import React from "react";
import { UserIdPill } from "../common/UserPill";
import LoadingIcon from "../common/LoadingIcon";
import { useBoard } from "../../utils/hooks/commonly-stored/uploaded-board/board";
import { useShipments } from "../../utils/hooks/commonly-stored/uploaded-board/shipments";

export default function BoardOption({
  board,
  currentUserId,
  selected,
}: {
  board: Board;
  currentUserId?: string | null;
  selected?: boolean;
}) {
  const { shipments } = useShipments(board.id);

  const latestShipment = shipments?.find(
    (shipment) => shipment.production_status == ProductionStatus.MANUFACTURING,
  );

  return (
    <OptionContainer selected={selected}>
      <OptionLine selected={selected}>
        <OptionTitle selected={selected}>{board.project_name}</OptionTitle>
        {board.user_id !== null && board.user_id != currentUserId && (
          <UserIdPill userId={board.user_id} />
        )}
      </OptionLine>
      <OptionLine selected={selected}>
        <div>
          {latestShipment?.ship_date
            ? `Ship date: ${dateStringToHumanReadableDate(latestShipment.ship_date)}`
            : `Uploaded: ${dateStringToHumanReadableDate(
                board.datetime_uploaded,
              )}`}
        </div>
        <div>Id: {board.id}</div>
      </OptionLine>
    </OptionContainer>
  );
}

export function BoardOptionFromId({
  boardId,
  currentUserId,
  selected,
}: {
  boardId: string;
  currentUserId?: string | null;
  selected?: boolean;
}) {
  const { board } = useBoard(boardId);

  if (board === null) {
    return <LoadingIcon />;
  }
  return (
    <BoardOption
      board={board}
      currentUserId={currentUserId}
      selected={selected}
    />
  );
}
